@if (visible && (!isDataComponent() || showEditButtons)) {
  <div
    class="contextual-toolbar tw-shadow-lg"
    [class.contextual-toolbar--placement-left]="placement === 'left'"
    [class.contextual-toolbar--placement-right]="placement === 'right'"
    [style.top]="positionStyle.top"
    [style.left]="positionStyle.left"
    role="toolbar"
    aria-label="Component actions"
  >
    @if (showAiButton) {
      <button
        type="button"
        class="contextual-toolbar-btn"
        [attr.aria-label]="aiButtonLabel"
        (click)="onAiClick()"
      >
        <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
      </button>
    }
    @if (!isDataComponent() && !playlistItem) {
      <button
        type="button"
        class="contextual-toolbar-btn"
        aria-label="Hide component"
        (click)="onHideClick()"
      >
        <mat-icon svgIcon="eye-close" aria-hidden="true"></mat-icon>
      </button>
    }
    @if (showEditButtons) {
      <button
        type="button"
        class="contextual-toolbar-btn"
        aria-label="Duplicate component"
        (click)="onDuplicateClick()"
      >
        <mat-icon svgIcon="duplicate" aria-hidden="true"></mat-icon>
      </button>
      <button
        type="button"
        class="contextual-toolbar-btn"
        aria-label="Delete component"
        (click)="onDeleteClick()"
      >
        <mat-icon svgIcon="trash" aria-hidden="true"></mat-icon>
      </button>
    }
  </div>
}
